// extracted by mini-css-extract-plugin
export default {"icon":"CenterIcon_icon__FHDRW","pulse":"CenterIcon_pulse__hjG8s","float":"CenterIcon_float__-sPbe"};